<template>
  <div>
    <v-stepper v-model="stepperval" vertical >
      <v-stepper-step
        :complete="step1complete"
        step="1"
        @click="openCloseStep(1)"
      >
        Follow-up type
      </v-stepper-step>
      <v-stepper-content step="1">
        Contact person - {{ selectedContact.ACCONDET_NAME }}
        <v-card color="grey lighten-1" class="my-5">
          <GmapMap
            :center="{ lat: myLocation.latitude, lng: myLocation.longitude }"
            :zoom="zoom"
            map-type-id="roadmap"
            style="width: 100%; height: 20vh"
          >
            <GmapMarker
              :position="{
                lat: myLocation.latitude,
                lng: myLocation.longitude,
              }"
              :clickable="true"
              :draggable="false"
            />
            <GmapMarker
              :position="{
                lat: tgtLocation.latitude,
                lng: tgtLocation.longitude,
              }"
              :clickable="true"
              :draggable="false"
            />
          </GmapMap>
        </v-card>
        <v-row dense>
          <v-col cols="9">
            <p class="caption">
              You are approx {{ distBtw }} km away from the selected contact
            </p>
          </v-col>
          <v-col cols="2" align="center">
            <v-btn x-small text class="primary--text" @click="refreshLoc">
              <v-icon>
                mdi-refresh
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row align="center" justify="end" dense>
            <v-btn text class="primary--text caption" @click="openMaps">
              open google maps
            </v-btn>
          </v-row>

        <v-radio-group
          v-model="selectedFlwUpType"
          row
          class="d-flex justify-center"
          dense
        >
          <v-radio label="Email" value="Email"></v-radio>
          <v-radio label="Call" value="Call"></v-radio>
          <v-radio
            label="Visit"
            value="Visit"
            :disabled="distBtw > 0.25"
          ></v-radio>
        </v-radio-group>

        <v-btn small color="primary" class="mb-2" @click="stepperval = 2">
          Continue
        </v-btn>
      </v-stepper-content>

      <v-stepper-step
        :complete="step2complete"
        step="2"
        @click="openCloseStep(2)"
      >
        Follow-up purpose  
      </v-stepper-step>

      <v-stepper-content step="2">
        <v-select
          :items="flwUpTypes"
          item-value="val"
          item-text="label"
          solo
          v-model="selectedFlwUpPurpose"
          label="Purpose"
          class="mx-2"
        ></v-select>
        <div v-if="this.selectedFlwUpPurpose == 'sale'||this.selectedFlwUpPurpose == 'survey'">
          <v-row dense>
            <p class="mx-5 subtitle-2">Please select the products discussed</p>
            <v-col v-for="item in pitchItemList" :key="item.value" cols="6">
              <v-card class="ma-1" height="100px">
                <v-img
                  :src="require(`@/assets/product_images/${item.value}.png`)"
                  class="grey--text align-end mx-3"
                  height="50px"
                  max-width="200px"
                  contain
                >
                </v-img>
                <v-checkbox
                  class="ma-1"
                  v-model="pitchedItems"
                  :value="item.value"
                  :label="item.label"
                >
                </v-checkbox>
              </v-card>
            </v-col>
          </v-row>
        </div>

        <div v-if="this.selectedFlwUpPurpose == 'collection'">
          <v-row class="d-flex align-center" dense>
            <p class="mx-5 subtitle-2">Please select the months discussed</p>
            <v-data-table
              dense
              v-model="selectedOutsMonths"
              :headers="outsMonthlyHeaders"
              :items="customeroutsmonthly"
              :single-select="singleSelect"
              item-key="CUSTOUTS_DOCMONTHYEAR"
              show-select
              class="elevation-3 mx-2 body-2"
              width="100%"
            >
            </v-data-table>
          </v-row>
        </div>
        <div v-if="this.selectedFlwUpPurpose == 'SOF'">
         <v-flex> <p>Must select a valid date for expected forcasting month</p></v-flex>
        <v-flex>
          <v-text-field
            label="SOF Validity"
            v-model="sofvdate"
            prepend-icon="event"
            readonly
            @click="viewdatepicker = true"
          ></v-text-field>
          <v-dialog
            :close-on-content-click="false"
            v-model="viewdatepicker"
            max-width="290px"
            min-width="290px"
            :min-date='new Date().toISOString().substr(0, 10)'            
          >
            <v-date-picker v-model="sofvdate" no-title scrollable actions>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="viewdatepicker = false"
                  >Cancel</v-btn
                >
                <v-btn text color="primary" @click="viewdatepicker = false"
                  >OK</v-btn
                >
              </v-card-actions>
            </v-date-picker>
          </v-dialog>
        </v-flex>
        </div>
        <div v-if="this.selectedFlwUpPurpose == 'SQ'">
         <v-flex> <p>Must select a valid date for expected within 30 days</p></v-flex>
        <v-flex>
          <v-text-field
            label="SQ Validity"
            v-model="sqvdate"
            prepend-icon="event"
            readonly
            @click="viewdatepicker = true"
          ></v-text-field>
          <v-dialog
            :close-on-content-click="false"
            v-model="viewdatepicker"
            max-width="290px"
            min-width="290px"
            :min-date='new Date().toISOString().substr(0, 10)'            
          >
            <v-date-picker v-model="sqvdate" no-title scrollable actions>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="viewdatepicker = false"
                  >Cancel</v-btn
                >
                <v-btn text color="primary" @click="viewdatepicker = false"
                  >OK</v-btn
                >
              </v-card-actions>
            </v-date-picker>
          </v-dialog>
        </v-flex>
        </div>

        <v-btn small color="primary" class="my-2" @click="stepperval = 3">
          Continue
        </v-btn>
      </v-stepper-content>

      <v-stepper-step
        :complete="step3complete"
        step="3"
        @click="openCloseStep(3)"
      >
        Follow-up result
      </v-stepper-step>

      <v-stepper-content step="3">
        <!-- <v-select
          :items="flwUpRes"
          item-value="val"
          item-text="label"
          solo
          v-model="selectedFlwUpResult"
          label="Result"
          class="mx-2"
        ></v-select> -->

        <v-switch
          v-model="isselectedFlwUpResult"
          :label="'Got ' + selectedFlwUpResult"
          color="primary"                 
          class="mx-6"
        ></v-switch>

        <v-dialog v-model="prodadddialog" max-width="340">
          <Addeditproduct
            v-on:showProductDialog="prodselectdialog = true"
            v-on:hideProductDialog="prodadddialog = false"
          />
        </v-dialog>
        <v-dialog v-model="prodselectdialog" max-width="340">
          <Prodselect v-on:hideSelectProduct="prodselectdialog = false" />
        </v-dialog>
        <div v-if="this.selectedFlwUpResult == 'order'">
          <v-card class="mx-1 blue-grey darken-1 white--text">
            <v-row>            
              <v-col cols="8">
                <!-- <div v-if="this.thisflwuppurpose() =='SOF'"> Forcast </div> -->
                <p class="ml-2 font-weight-bold text-h5 d-flex justify-start">                   
                  {{this.thisordertype }} Items:
                </p>
              </v-col>
              <v-col cols="4" class="d-flex justify-end">
                <v-btn small class="mr-3">
                  <v-icon
                    class="blue-grey--text text--darken-1"
                    @click="prodadddialog = true"
                  >
                    add
                  </v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <div
              v-for="product in selectedProductsList"
              :key="product.STKMST_DOCNO"
            >
              <v-row dense>
                <v-col cols="4">
                  <v-list-item-subtitle
                    class="caption text-wrap mx-3 my-1 grey--text text--lighten-1"
                  >
                    Code:
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="body-2 text-wrap mx-3 my-1">
                    {{ product.STKMST_DOCNO }}
                  </v-list-item-subtitle>
                </v-col>
                <v-col cols="8">
                  <v-list-item-subtitle
                    class="caption text-wrap mx-3 my-1 grey--text text--lighten-1"
                  >
                    Stock:
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="caption text-wrap mx-3 my-1">
                    {{ product.STKMST_DESC }}
                  </v-list-item-subtitle>
                </v-col>
                <v-btn
                  elevation="0"
                  text
                  x-small
                  style="position: absolute; right: 10px;"
                  class=""
                  @click="removeSelectedProduct(product)"
                >
                  <v-icon class="white--text">
                    backspace
                  </v-icon>
                </v-btn>
              </v-row>
              <v-row dense>
                <v-col cols="4">
                  <v-list-item-subtitle
                    class="caption text-wrap mx-3 my-1 grey--text text--lighten-1"
                  >
                    Qty:
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="body-2 text-wrap mx-3 my-1">
                    {{ product.SO_QTY }}
                  </v-list-item-subtitle>
                </v-col>
                <v-col cols="3">
                  <v-list-item-subtitle
                    class="caption text-wrap mx-3 my-1 grey--text text--lighten-1"
                  >
                    Rate:
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="body-2 text-wrap mx-3 my-1">
                    {{ product.SO_RATE }}
                  </v-list-item-subtitle>
                </v-col>
                <v-col cols="5">
                  <v-list-item-subtitle
                    class="caption text-wrap mx-3 my-1 grey--text text--lighten-1"
                  >
                    Total:
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="body-2 text-wrap mx-3 my-1">
                    {{ product.SO_LINE_TOTAL }}
                  </v-list-item-subtitle>
                </v-col>
                <v-col cols="12">
                  <v-divider class="white" />
                </v-col>
              </v-row>
            </div>
            <v-row class="d-flex justify-center align-center">
              <v-col cols="7">
                <div class="d-flex justify-start mx-3 py-2">
                  Order total: {{ sototal }}
                </div>
              </v-col>
              <v-col cols="5">
                <!-- <v-btn
                  class="d-flex justify-center mx-1 my-5 blue-grey--text text--darken-1"
                >
                  <v-icon>
                    save
                  </v-icon>
                </v-btn> -->
              </v-col>
            </v-row>
            <div class="ma-2">
          Delivery to:
          <v-select
            return-object
            :items="allContacts"
            item-text="ACCONDET_NAME"
            solo
            v-model="selectedDeliveryContact"
            label="Deliver to"
            class="mx-2"
          ></v-select>
          <v-text-field 
            v-model="lpoNo"
            label="LPO NO:">
          </v-text-field>      
          <!-- <lpoimage/> -->
            <v-file-input
               :rules="lpoAttRules"
                show-size  
                accept="image/jpg, image/jpeg,application/pdf"
                label="Click to Attach LPO"
                outlined
                v-model="selectedFile"
                @change="importFile"
            >
            </v-file-input>
            <!-- <v-card-title>File Selected</v-card-title> -->
            <!-- <v-card-text><p>{{ fileSelected }}</p></v-card-text> -->
            <v-col cols="auto">
            <v-row
              align="center"
              justify="space-around"
            > 
            <v-img     
            align="center"
            justify="space-around"       
            max-height="500"
            max-width="250"
            :src="fileSelected"></v-img>  
            </v-row>
            </v-col>
            </div>            
          </v-card>
        </div>
        <div v-if="this.selectedFlwUpResult == 'collection'">
          <v-row class="d-flex align-center" dense>
            <p class="mx-5 subtitle-2">Please select the invoices collected</p>
            <v-data-table
              dense
              v-model="selectedOutsDocs"
              :headers="outsDocHeaders"
              :items="customeroutstandingdocslist"
              :single-select="singleSelect"
              item-key="CUSTOUTS_DOCNO"
              show-select
              class="elevation-3 mx-2 body-2"
              width="100%"
            >
            </v-data-table>
          </v-row>
         </div>
         <v-btn small color="primary" class="my-2" @click="stepperval = 4">
          Continue
         </v-btn>
      </v-stepper-content>

      <v-stepper-step
        :complete="step4complete"
        step="4"
        @click="openCloseStep(4)"
      >
        Next follow-up
      </v-stepper-step>

      <v-stepper-content step="4">
        <v-radio-group
          v-model="selectedNextFlwUpType"
          row
          dense
          class="d-flex justify-center"
        >
          <v-radio label="Email" value="email"></v-radio>
          <v-radio label="Call" value="call"></v-radio>
          <v-radio label="Visit" value="visit"></v-radio>
        </v-radio-group>

        <v-flex>
          <v-text-field
            label="Appointment date"
            v-model="apmtdate"
            prepend-icon="event"
            readonly
            @click="viewdatepicker = true"
          ></v-text-field>
          <v-dialog
            :close-on-content-click="false"
            v-model="viewdatepicker"
            max-width="290px"
            min-width="290px"
          >
            <v-date-picker v-model="apmtdate" no-title scrollable actions>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="viewdatepicker = false"
                  >Cancel</v-btn
                >
                <v-btn text color="primary" @click="viewdatepicker = false"
                  >OK</v-btn
                >
              </v-card-actions>
            </v-date-picker>
          </v-dialog>
        </v-flex>
        <v-row class="ml-3 mb-2">
          <small> Selected day's meetings</small>
        </v-row>
        <GmapMap
          :center="{ lat: myLocation.latitude, lng: myLocation.longitude }"
          :zoom="zoom"
          map-type-id="roadmap"
          style="width: 100%; height: 40vh"
        >
          <GmapMarker
            :position="{
              lat: myLocation.latitude,
              lng: myLocation.longitude,
            }"
            :clickable="true"
            :draggable="false"
          />
          <GmapMarker
            :position="{
              lat: tgtLocation.latitude,
              lng: tgtLocation.longitude,
            }"
            :clickable="true"
            :draggable="false"
          />
        </GmapMap>

        <v-textarea
          outlined
          class="my-5"
          name="input-7-4"
          v-model="apmtnotes"
          label="Pre-meeting notes"
          :hint="remapmtnoteschar"
          value=""
        ></v-textarea>

        <v-btn small color="primary" class="mb-2" @click="stepperval = 5">
          Continue
        </v-btn>
      </v-stepper-content>

      <v-stepper-step
        :complete="step5complete"
        step="5"
        @click="openCloseStep(5)"
      >
        Additional remarks Mandatory
      </v-stepper-step>
      <v-stepper-content step="5">
        <v-textarea
          outlined          
          class="my-5"
          name="input-7-4"          
          v-model="addnlnotes"
          label="Additional notes"
          :counter="200"
          :hint="remadnlnoteschar"
          :rules="[remarksRules.required,remarksRules.min]"
          value=""
          @input="updateData"                   
        ></v-textarea>
      </v-stepper-content>

      <v-dialog v-model="savedialog">
        <v-card class="blue-grey darken-1 white--text" dark flat>
          <p class="d-flex justify-center title white--text mb-5">
            Entry checklist
          </p>
          <v-progress-linear
            color="primary"
            height="10"
            :buffer-value="progval"
            :value="progval"
            stream
          ></v-progress-linear>
          <div class="mx-2">
            <v-checkbox
              dense
              class="subtitle-2 my-0"
              v-model="step1complete"
              disabled
              label="Type is visit?"
            />
            <v-checkbox
              dense
              class="subtitle-2 my-0"
              v-model="step2complete"
              disabled
              label="Sales / collection discussed?"
            />
            <v-checkbox
              dense
              class="subtitle-2 my-0"
              v-model="step3complete"
              disabled
              label="Got order (or) collection successful?"
            />
            <v-checkbox
              dense
              class="subtitle-2 my-0"
              v-model="step4complete"
              disabled
              label="Next follow-up planned?"
            />
            <v-checkbox
              dense
              class="subtitle-2 my-0"
              v-model="step5complete"
              disabled
              label="Additional remarks added?"
            />
          </div>
          <v-row align="center" justify="space-around">
            <v-col cols="6" class="d-flex justify-center">
              <v-btn large text class="" dark @click="savedialog = false">
                <v-icon left>
                  cancel
                </v-icon>
                CANCEL
              </v-btn>
            </v-col>
            <v-col cols="6" class="d-flex justify-center">
              <v-btn large class="primary" dark @click="saveFinalEntry">
                <v-icon left>
                  save
                </v-icon>
                SAVE
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>

      <v-row align="center" justify="space-around">
        <v-col cols="12" class="d-flex justify-center">
          <v-btn large class="primary" dark @click="savedialog = true">
            <v-icon left>
              save
            </v-icon>
            SAVE
          </v-btn>
        </v-col>
      </v-row>
      <p class="caption mx-3 mt-3">
        * Enty saved cannot be edited. Please check each step is completed
        before saving
      </p>
      <p class="caption mx-3">
        * This entry will affect on your KPIs and KPI based evaluations
      </p>
    </v-stepper>
    <v-dialog v-model="showPop" max-width="290" persistent>
      <Popup />
    </v-dialog>
  </div>
</template>

<script>
import Addeditproduct from "@/components/Addeditproduct";
import Prodselect from "@/components/Prodselect";
import Popup from "@/components/Popup";
import secure_axios from "../services/secure_axios";

export default {
  name: "JournalEntry",
  components: {
    Addeditproduct,
    Prodselect,
    Popup,
  },
  data() {
    return {
      zoom: 10,
      stepperval: 0,
      selectedFlwUpType: "Email",
      prodadddialog: false,
      prodselectdialog: false,      
      flwUpTypes: [
        { val: "sale", label: "Sale" },
        { val: "collection", label: "Collection" },
        { val: "survey", label: "Survey" },
        { val: "SOF",label: "Sales Forcast"},
        { val: "SQ",label: "Sales Quotation"}
      ],
      flwUpRes: [
        { val: "order", label: "Got order" },
        //{ val: "collection", label: "Successful collection" },
      ],
      selectedFlwUpPurpose: "",
      pitchItemList: [
        { label: "Montage adhesive", value: "montage" },
        { label: "Auto sealants", value: "auto" },
        { label: "Marine sealants", value: "marine" },
        { label: "Bath & Kitchen", value: "bk" },
        { label: "SG 71", value: "sg_71" },
        { label: "GP PRO", value: "gp_pro" },
        { label: "Weather FS", value: "w70_fs" },
        { label: "Fire Rated FS", value: "fire_rated_fs" },
        { label: "Acrylic FS / FR ", value: "acrylic_fr_fs" },
        { label: "Intucryl", value: "intucryl" },
        { label: "Weather sealant", value: "weather" },
        { label: "IG /Polysul.", value: "ig_polysulphide" },
        { label: "Acrylic sealant", value: "acrylic" },
        { label: "PU sealants", value: "pu" },
        { label: "Tritosil GP", value: "gp" },
        { label: "Easyseal 3000", value: "3000" },
        { label: "Easyseal 1200", value: "1200" },
        { label: "EZ 100", value: "100" },
        { label: "Foam B2 / B1", value: "b2" },
        { label: "Foam 750ml", value: "foam_750" },
        { label: "Foam 750ml XL", value: "foam_xl" },
        { label: "Backer rod", value: "b_rod" },
        { label: "HDST", value: "hdst" },
        { label: "Al tape", value: "al_tape" },
        { label: "DG Tape", value: "dg_tape" },
        { label: "BOPP Tape", value: "bopp_tape" },
        { label: "DS Tape", value: "ds_tape" },
        { label: "Masking tape", value: "msk_tape" },
        { label: "Shower fittings", value: "shw_fitt" },
        { label: "Protexn. tape", value: "prt_tape" },
        { label: "Al. door accs.", value: "al_door_accs" },
        { label: "Dbl Glz accs.", value: "dg_accs" },
      ],
      selectedOutsMonths: [],
      outsMonthlyHeaders: [
        { text: "Month", sortable: true, value: "CUSTOUTS_DOCMONTHYEAR" },
        { text: "Amount", value: "CUSTOUTS_OUTSTANDING" },
      ],
      selectedOutsDocs: [],
      outsDocHeaders: [
        { text: "Date", sortable: true, value: "CUSTOUTS_DOCDATE" },
        { text: "Inv no.", value: "CUSTOUTS_DOCNO" },
        { text: "Amount", value: "CUSTOUTS_OUTSTANDING" },
      ],
      pitchedItems: [],
      singleSelect: false,
      isselectedFlwUpResult: false,
      // selectedFlwUpResult: "",
      surveynum: "",
      selectedNextFlwUpType: "",
      viewdatepicker: false,
      today: new Date().toISOString().substr(0, 10),
      apmtdate: new Date().toISOString().substr(0, 10),
      sofvdate: "",
      sqvdate:"",
      apmtnotes: "",
      addnlnotes: "",
      savedialog: false,
      progval: 0,
      jnlmsg: "",
      somsg: "",
      apmsg: "",
      selectedDeliveryContact:null,
      lpoNo: "",  
      lpobase64:null,    
      selectedFile:null,
      fileSelected:null,
      sotype:"",
      isSOrespons:false,
      lpoAttRules: [
        value => !value || value.size < 2000000 || 'size should be less than 2 MB!',
      ],
      remarksRules:{
        required : (value) => !!value || "Required.",
        min: (v) => (v && v.replace(/^\s+|\s+$/gm,'').length >= this.minofadditionalnote) || `Min ${this.minofadditionalnote} characters`,
      }
    };
  },
  computed: {   
    sessionAPI() {
      return this.$store.getters.sessionAPI;
    },
    selectedContact() {
      return this.$store.getters.thiscontact;
    },
    myLocation() {
      return this.$store.getters.myLocation;
    },
    tgtLocation() {
      return this.$store.getters.tgtLocation;
    },
    distBtw() {
      return this.$store.getters.distBtw;
    },
    customeroutstandingdocslist() {
      return this.$store.getters.customeroutsdocs;
    },
    customeroutsmonthly() {
      return this.$store.getters.customeroutsmonthly;
    },
    allProductsList() {
      return this.$store.getters.allProducts;
    },
    selectedProductsList() {
      return this.$store.getters.selectedProducts;
    },
    allContacts() {
      return this.$store.getters.allcontacts;
    },  
    minofadditionalnote(){
      if (this.selectedFlwUpResult =='order' && this.selectedProductsList.length > 0 && this.selectedDeliveryContact != null) 
      {
        return 15;
      } else {
        return 25;
      }
    },  
    soStatus(){
      return this.$store.getters.soStatus;
    },
    selectedFlwUpResult(){
      if(["sale","SQ","SOF"].includes(this.selectedFlwUpPurpose)){
        return this.isselectedFlwUpResult ? "order" : "no order";
      } else if(this.selectedFlwUpPurpose == "collection" ){
      return this.isselectedFlwUpResult ? "collection" : "no collection";
      } else  return "NA"
    },
    step1complete() {
      if (this.selectedFlwUpType && this.selectedContact.ACCONDET_NAME != null) {
        return true;
      } 
      else if (this.selectedContact.ACCONDET_NAME == null) {        
        let finalmsg = "Cannot save entry. Please select the contact person"
        this.showfailure(finalmsg);
        return false;
      } 
      else{
        return false;
      }
    },
    step2complete() {
      if (this.selectedOutsMonths.length > 0 || this.pitchedItems.length > 0 || 
          this.sofvdate > this.today || this.sqvdate > this.today) {
        return true;
      } else {
        return false;
      }
    },
    step3complete() {
      if (
        this.selectedFlwUpResult.length > 0 &&
        this.selectedProductsList.length > 0 &&
        this.selectedDeliveryContact != null
      ) {
        return true;
      } else {
        return false;
      }
    },
    step4complete() {
      if (this.apmtdate > this.today && this.selectedNextFlwUpType != "") {
        return true;
      } else {
        return false;
      }
    },

    step5complete() {
      if (this.addnlnotes.length > this.minofadditionalnote && this.addnlnotes !="" && this.addnlnotes.length <= 200) {
        return true;
      } 
      // else if (this.thisflwuppurpose == 'SOF' && this.addnlnotes.length > 20){
      //   return true;
      // } else if (this.selectedProductsList.length > 0 && this.addnlnotes.length > 10 ){ 
      //   return true;
      // } 
      else{
        return false;
      }
    },
    thiscustomer() {
      return this.$store.getters.thiscustomer;
    },
    sototal() {
      if (this.selectedProductsList.length > 0) {
        return this.selectedProductsList
          .map((item) => item.SO_LINE_TOTAL)
          .reduce((prev, next) => prev * 1 + next * 1);
      } else {
        return 0;
      }
    },
    remapmtnoteschar() {
      return `characters remaining: ${200 - this.apmtnotes.length.toString()}`;
    },
    remadnlnoteschar() {
      return `characters remaining: ${200 - this.addnlnotes.length.toString()}`;
    },
    thisuser() {
      return this.$store.getters.factsuser;
    },
    thisflwuppurpose() {
      if (this.selectedOutsMonths.length > 0 && this.pitchedItems.length > 0) {
        return "sales&collection";
      } else if (this.selectedOutsMonths.length > 0) {
        return "collection";
      } else if (this.pitchedItems.length > 0) {
        return "sale";
      } else if (this.sofvdate > this.today) {
        return "SOF";
      } else if (this.sqvdate > this.today) {
        return "SQ";
      } else {
        return "";
      }
    },
    thisordertype(){
      if (this.thisflwuppurpose == "sale"){
        return "SO";
      } else if (this.thisflwuppurpose == "SOF"){
        return "SOF";
      } else if (this.thisflwuppurpose == "SQ"){
        return "SQ";
      } else {
        return "";
      }
    },
    thisexptdeldate(){
      if(this.thisflwuppurpose == "SOF" && this.sofvdate > this.today){
         return this.sofvdate
      } else {
        return this.today
      }
     
    },
    thisSQvalidity(){
      let date = new Date(); // Now
      date.setDate(date.getDate() + 30);
      return (this.date)
    },
    showPop() {
      return this.$store.getters.showPop;
    },
    selectedDeliveryContactGPS() {
      return `${this.selectedDeliveryContact.ACCONDET_GPSLAT}, ${this.selectedDeliveryContact.ACCONDET_GPSLON}`;
    },   
  },

  methods: {
    openCloseStep(stepval) {
      this.stepperval == stepval
        ? (this.stepperval = 0)
        : (this.stepperval = stepval);
    },
    refreshLoc() {
      // this.$store.dispatch("getMyLocation");
      // this.$store.dispatch("getTgtLocation");
      this.$store.dispatch("getDistBetween");
      // console.log(this.allProductsList);
    },
    showif() {
      console.log(this.selectedFlwUpPurpose);
    },
    removeSelectedProduct(product) {
      this.$store.dispatch("removeProductFromList", product);
    },
    setSoStatus(stat){
      this.$store.dispatch("setSoStatus",stat);
    },  
    openMaps() {
      window.open("https://maps.google.com/");
    },
    updateData(input) {
    this.dataValue = input.replace(' ', '');
    },
    postJnl() {
      const asyncpostJnl = async () => {       
        const jnl_hdr_data = {
          custcode:
            this.thiscustomer.PARTYMST_DOCTYPE +
            "-" +
            this.thiscustomer.PARTYMST_DOCNO,
          custname: this.thiscustomer.PARTYMST_DESC,
          smancode: this.thiscustomer.CUST_SMAN_DOCNO,
          smanname: this.thiscustomer.SMAN_DESC,
          crbyname: this.thisuser.USER_NAME,
          crbydesg: this.thisuser.USER_UD_LABEL2,
          contsrno: this.selectedContact.ACCONDET_DOCSRNO,
          contperson: this.selectedContact.ACCONDET_NAME,
          tgtloc: this.tgtLocation.latitude + ", " + this.tgtLocation.longitude,
          myloc: this.myLocation.latitude + ", " + this.myLocation.longitude,
          distgt: this.distBtw,
          flwtype: this.selectedFlwUpType,
          flwpps: this.thisflwuppurpose,
          flwres: this.selectedFlwUpResult,
          nxttype: this.selectedNextFlwUpType,
          nxton: this.apmtdate,
          contisver: this.selectedContact.ACCONDET_REMARKS,
          crbyid: this.thisuser.USER_DOCNO,
          rem: this.addnlnotes,
        };

        var jd_items = [];

        this.pitchedItems.forEach((i) => {
          var jd_item = new Object();

          jd_item.custcode =
            this.thiscustomer.PARTYMST_DOCTYPE +
            "-" +
            this.thiscustomer.PARTYMST_DOCNO;
          jd_item.flwtype = this.selectedFlwUpType;
          jd_item.flwpps = this.thisflwuppurpose;
          jd_item.surnum = 0;
          jd_item.itcode = i.STKMST_DESC;
          jd_item.itdesc = i.STKMST_DOCNO;
          jd_item.itunit = i.STTRN_UNIT_DOCNO;
          jd_item.itqty = 0;
          jd_item.itprice = 0;
          jd_item.itamt = 0;

          jd_items.push(jd_item);
        });

        this.selectedOutsMonths.forEach((i) => {
          var jd_item = new Object();

          jd_item.custcode =
            this.thiscustomer.PARTYMST_DOCTYPE +
            "-" +
            this.thiscustomer.PARTYMST_DOCNO;
          jd_item.flwtype = this.selectedFlwUpType;
          jd_item.flwpps = "collection";
          jd_item.surnum = 0;
          jd_item.itcode = i.CUSTOUTS_DOCMONTHYEAR;
          jd_item.itdesc = i.CUSTOUTS_DOCMONTHYEAR;
          jd_item.itunit = "";
          jd_item.itqty = 0;
          jd_item.itprice = 0;
          jd_item.itamt = i.CUSTOUTS_OUTSTANDING;

          jd_items.push(jd_item);
        });

        this.progval = 25;

        try {
          const jnl_resp = await secure_axios.post(this.sessionAPI + "journal", {
            hdr_data: jnl_hdr_data,
            det_data: jd_items,
          });
          if(jnl_resp.status == 201){
            const jnl_no = jnl_resp.data.journal;
            this.jnlmsg = `New journal no: ${jnl_no}`;
          }     
          return jnl_resp;         
        } catch (err) {
          // Handle Error Here
          console.error(err);          
          // throw error to return it to caller
          throw err;
        }        
      };
      return asyncpostJnl();
    },
    postSO() {
      const asyncpostSO = async () => {  
        const so_hdr_data = {
          acdoctype: this.thiscustomer.PARTYMST_DOCTYPE,
          acdocno: this.thiscustomer.PARTYMST_DOCNO,
          smanno: this.thiscustomer.CUST_SMAN_DOCNO,
          contno: this.selectedDeliveryContact.ACCONDET_DOCSRNO,
          contname: this.selectedDeliveryContact.ACCONDET_NAME,
          gross_amt: this.sototal,
          other_amt: 0,
          net_amt: this.sototal * 1.05,
          custdiv: Number(this.thiscustomer.PARTYMST_DIVN_DOCNO),
          uid: this.thisuser.USER_LOGINID,
          refno: this.lpoNo,
          tgtloc: this.tgtLocation.latitude + ", " + this.tgtLocation.longitude,
          lpobase64:this.lpobase64 ,
          ordertype:this.thisordertype,
          expt_del_date:this.thisexptdeldate
        };

        var so_items = [];

        this.selectedProductsList.forEach((i) => {
          var so_item = new Object();

          so_item.amt = i.SO_LINE_TOTAL;
          so_item.qty = i.SO_QTY;
          so_item.rate = i.SO_RATE;
          so_item.price = i.STKMST_AVERAGE_COST;
          so_item.stkdesc = i.STKMST_DESC;
          so_item.stkcode = i.STKMST_DOCNO;
          so_item.unit = i.STTRN_UNIT_DOCNO;
          so_item.g_amt = i.SO_LINE_TOTAL * 1.05;
          so_item.vat_amt = i.SO_LINE_TOTAL * 0.05;

          so_items.push(so_item);
        });
        this.progval = 75;       
        try {          
          const so_resp = await secure_axios.post(this.sessionAPI + "salesorder", {          
            hdr_data: so_hdr_data,
            det_data: so_items,
          });
          if(so_resp.status == 201){
            const so_no = so_resp.data.new_so;
            this.somsg = `and new sales order no:${so_no}`;
            this.$store.dispatch("setSoStatus","success")
            this.$store.dispatch("clearThisProductsList")
          }else{
            this.somsg = `Error! ${this.thisordertype} not saved.`;            
            this.$store.dispatch("setSoStatus","pending")
          }
          return so_resp;
        } catch (err) {
            // log error
          console.error(err);    
          this.somsg = `Error! ${this.thisordertype} not saved.`;   
          this.$store.dispatch("setSoStatus","pending")     
          // throw error to return it to caller
          throw err;
        }       
      };
     return asyncpostSO();
    },

    async showfailure(finalmsg) {
      
      // const finalmsg = "Cannot save entry. Please enter the journal purpose";
      await this.$store.dispatch("getMsgColor", "tomato");
      await this.$store.dispatch("getMsgHeading", "Uh oh!");
      await this.$store.dispatch("getMsgText", finalmsg);
      this.savedialog = false;
      await this.$store.dispatch("getShowPop", true);
      this.msgdialog = true;

      console.log(finalmsg);
      await this.$store.dispatch("getLoading", false);
    },  

    async  showerror(finalmsg) {      
     
      // const finalmsg = "Cannot save entry. Please enter the journal purpose";
      await this.$store.dispatch("getMsgColor", "red darken-1");
      await this.$store.dispatch("getMsgHeading", "Error!!");
      await this.$store.dispatch("getMsgText", finalmsg);
      this.savedialog = false;
      await this.$store.dispatch("getShowPop", true);
      this.msgdialog = true;

      console.log(finalmsg);
      await this.$store.dispatch("getLoading", false);
    }, 
    async showwarning(finalmsg) {      
      
      // const finalmsg = "Cannot save entry. Please enter the journal purpose";
      await this.$store.dispatch("getMsgColor", "yellow darken-1");
      await this.$store.dispatch("getMsgHeading", "Attention !");
      await this.$store.dispatch("getMsgText", finalmsg);
      this.savedialog = false;
      await this.$store.dispatch("getShowPop", true);
      this.msgdialog = true;

      console.log(finalmsg);
      await this.$store.dispatch("getLoading", false);
    }, 
    async showsuccess(finalmsg) {
      await this.$store.dispatch("getMsgColor", "limegreen");
      await this.$store.dispatch("getMsgHeading", "Success!");
      await this.$store.dispatch("getMsgText",finalmsg);
      await this.$store.dispatch("getShowPop", true);

      console.log(finalmsg);
      await this.$store.dispatch("getLoading", false);
      await this.$router.push("/customerlist");
    },    

    postAppointments(){
      const asyncpostAppointments = async () => {        

        const apmt_data = {
          AP_CreatedJNo:null,
          AP_CustCode:null,
          AP_CustName:null,
          AP_ByName:null,
          AP_ByDesg:null,
          AP_SmanID:null,
          AP_AsToID:null,
          AP_TS:null,
          AP_ApType:null,
          AP_ApDate:null,
          AP_Notes:null,
          AP_ContactPerson:null,
          AP_Loc:null,
          AP_ByID:null,
          AP_Cont_SrNo:null,
          AP_Cont_IsVerified:null,
          AP_CustType:null,
          AP_FulfilledTS: null,
          AP_FulfilledJNo: null
        };

        try {          
          const ap_resp = await secure_axios.post(this.sessionAPI + "appointment", {         
            apmt_data: apmt_data
          });
          const ap_no = ap_resp.data;
          this.apmsg = `and ${ap_no}`;
          return ap_resp
        } catch (err) {
          // Handle Error Here
          console.error(err);
          this.apmsg = `Error! Appointment not saved.`;
          throw err;
        }                  
      };
      return asyncpostAppointments();
    },
    saveFinalEntry() {      
      if (this.step5complete) {
        if (this.step2complete) {
          // if (this.step3complete) {  
            this.$store.dispatch("getLoading", true);
            // Call both post request functions       
            const postJnlRequest = this.postJnl();
            const promisesToResolve = [postJnlRequest];
            //ORDER POSTING
            if(this.step3complete){
              const postSORequest = this.postSO();
              promisesToResolve.push(postSORequest);
            }
            // APPOINTMENT POSTING
            // if(this.step4complete){
            //   const postAppointmentsRequest = this.postAppointments();
            //   promisesToResolve.push(postAppointmentsRequest);
            // }
            
            // Wait for both requests to complete using Promise.all
            Promise.all(promisesToResolve)
              .then(responses => {               
                let finalmsg = `${this.jnlmsg} ${this.somsg} ${this.apmsg} for ${this.thiscustomer.PARTYMST_DESC}.`;
                // Get the response data from each response
                const responseData = responses.map(response => response.data);

                // Check the response status codes and display an alert accordingly
                const statusCodes = responses.map(response => response.status);
                if (statusCodes.every(status => status === 201)) {
                  console.log(responseData)
                  // alert(`Both post requests were successful. Response data: ${JSON.stringify(responseData)}`);                  
                  this.showsuccess(finalmsg)
                } else if (statusCodes.some(status => status === 201)) {
                  // alert(`One post request was successful. Response data: ${JSON.stringify(responseData)}`);
                  console.log(responseData)
                  this.showwarning(finalmsg)
                } else {
                  // alert('Both post requests failed.');
                  console.log(responseData)
                  this.showerror(finalmsg)
                }
              })
              .catch(error => {
                console.error(error);
                // alert('An error occurred while making the post requests.');
                this.showerror(`${this.jnlmsg} ${this.somsg} ${this.apmsg} for ${this.thiscustomer.PARTYMST_DESC}.`)
              });
          // } else {
          //   this.$store.dispatch("getLoading", true);
          //   // Call the postJnl function and display an alert based on its response
          //   this.postJnl()
          //     .then(response => {
          //       const finalmsg = `${this.jnlmsg} added for ${this.thiscustomer.PARTYMST_DESC}.`;
          //       if (response.status === 201) {
          //         alert(`The postJnl request was successful. Response data: ${JSON.stringify(response.data)}`);
          //         this.showsuccess(finalmsg)
          //       } else {
          //         alert('The postJnl request failed.');
          //         this.showerror(finalmsg)
          //       }
          //     })
          //     .catch(error => {
          //       console.error(error);
          //       alert('An error occurred while making the postJnl request.');
          //       this.showerror(error)
          //     });
          // }     
        } else { 
          let finalmsg = "Cannot save entry. Please enter the journal purpose"
          this.showfailure(finalmsg);
        }
      } else {
          let finalmsg = "Additional Remarks Mandatory for Jounral Entries" 
          this.showfailure(finalmsg);          
        }
    },  

    importFile(){
      if (!this.selectedFile) {this.fileSelected = "No File Chosen"}
      var reader = new FileReader();      
      // Use the javascript reader object to load the contents
      // of the file in the v-model prop
      reader.readAsDataURL(this.selectedFile);    
      // if(this.selectedFile && this.selectedFile.type.match('image.*'))
      if(this.selectedFile && this.selectedFile.size < 2097152){
        reader.onload = () => {
          this.fileSelected = reader.result;             
        } 
        reader.onloadend = () =>{         
          this.lpobase64 = JSON.stringify(this.fileSelected)          
        }        
      }
      else{
        let finalmsg= "File size is too high, please select a file less than 2 mb" 
        this.showfailure(finalmsg)
      }  
    },     
  },
  created() {},
};
</script>

<style scoped>  
</style>
